<template>
    <el-radio-group v-model="state" :size="size" @change="onChange">
        <el-radio v-for="it in radioData" :key="it.label" :label="it.label" :border="border" :disabled="disabled" >{{it.name}}</el-radio>
    </el-radio-group>
</template>

<script>
    export default {
        props: {
            value: [Number, String],
            size: {
                type: String,
                default: 'mini'
            },
            radioData: {
                type: Array,
                default: () => []
            },
            disabled: {
                type: Boolean,
                default: false
            },
            border: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                state: this.value
            }
        },
        watch: {
            value: {
                handler: function(val) {
                    this.state = val
                },
                immediate: true
            }
        },
        methods: {
            onChange(val) {
                this.$emit('input', val)
            },
        }
    }
</script>

<style scoped>
</style>